export const SITE_NAME = "Fapify";
export const SITE_URL = "https://www.fapify.com";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/social-media.png`;

export const PRIMARY_KEYWORDS = [
  "AI porn",
  "AI porn generator",
  "AI porn image generator",
  "AI porn video generator",
  "AI sex",
  "undress ai",
  "nudify ai",
  "ai nude",
  "nsfw ai",
  "nsfw ai generator",
  "nsfw ai art",
  "ai nude generator",
  "ai girlfriend",
  "best ai porn generator",
];

export const HOME_FAQS = [
  {
    question: "What can you create with Fapify?",
    answer:
      "Fapify lets you generate NSFW AI videos and edited images from templates, turn still images into motion, and run reusable AI porn workflows faster than starting from a blank prompt.",
  },
  {
    question: "Does Fapify support image-to-video generation?",
    answer:
      "Yes. Fapify supports image-to-video generation on compatible templates, and some flows also let you extend an existing video for a longer result.",
  },
  {
    question: "Does Fapify include undress AI or nude editing features?",
    answer:
      "Fapify includes compatible nudify and image editing flows on supported templates. Only upload consenting adult content that you are allowed to use.",
  },
  {
    question: "Is Fapify built for AI porn and NSFW AI workflows?",
    answer:
      "Yes. Fapify is positioned as an AI porn generator with public templates, NSFW AI creation flows, nudify-compatible edits, and repeatable creator workflows.",
  },
];

export const SEO_LINKS = [
  { label: "AI Porn", href: "/ai-porn" },
  { label: "AI Porn Generator", href: "/ai-porn-generator" },
  { label: "AI Porn Images", href: "/ai-porn-image-generator" },
  { label: "AI Porn Videos", href: "/ai-porn-video-generator" },
  { label: "AI Sex", href: "/ai-sex" },
  { label: "Porn Generator", href: "/porn-generator" },
  { label: "Undress AI", href: "/undress-ai" },
  { label: "Nudify AI", href: "/nudify-ai" },
  { label: "AI Nude", href: "/ai-nude" },
  { label: "AI Nude Generator", href: "/ai-nude-generator" },
  { label: "NSFW AI", href: "/nsfw-ai" },
  { label: "NSFW AI Generator", href: "/nsfw-ai-generator" },
  { label: "NSFW AI Art", href: "/nsfw-ai-image-generator" },
  { label: "AI Girlfriend", href: "/ai-girlfriend" },
  { label: "Make Porn", href: "/make-porn" },
];

export const buildAbsoluteUrl = (path = "/") => {
  if (!path) {
    return SITE_URL;
  }

  if (/^https?:\/\//.test(path)) {
    return path;
  }

  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/?search={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

export const buildWebApplicationSchema = ({
  name = `${SITE_NAME} AI Porn Generator`,
  description,
  url,
} = {}) => ({
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name,
  applicationCategory: "MultimediaApplication",
  operatingSystem: "Web",
  isAccessibleForFree: false,
  url,
  description,
});

export const buildBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: buildAbsoluteUrl(item.path),
  })),
});

export const buildFaqSchema = (faqItems) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
});

export const buildArticleSchema = ({
  headline,
  description,
  path,
  datePublished,
  dateModified,
  keywords = [],
} = {}) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline,
  description,
  author: {
    "@type": "Organization",
    name: SITE_NAME,
  },
  publisher: {
    "@type": "Organization",
    name: SITE_NAME,
    logo: {
      "@type": "ImageObject",
      url: DEFAULT_OG_IMAGE,
    },
  },
  mainEntityOfPage: buildAbsoluteUrl(path),
  datePublished,
  dateModified: dateModified || datePublished,
  keywords: keywords.join(", "),
  image: DEFAULT_OG_IMAGE,
});

export const buildItemListSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    url: buildAbsoluteUrl(item.path),
  })),
});

export const buildPageTitle = (title) =>
  title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
